<template>
  <div class="payment_result">
    <SuccessForm
      v-if="result.status === 'success'"
      :resultProps="result"
    />
    <FailedForm
      v-else
      :resultProps="result"
    />
  </div>
</template>
<script>
import SuccessForm from './successForm.vue';
import FailedForm from './failedForm.vue';

export default {
  name: 'Result',
  components: {
    SuccessForm,
    FailedForm
  },
  data() {
    return {
      result: {
        status: '',
        data: {}
      },
    }
  },
  // TODO 결제기능 6번 : 인보이스 정보 넘겨주기
  created() {
    if (this.$route.params.hasOwnProperty('result')) {
      this.result = this.$route.params.result;
    } else {
      this.$router.push('/options');
    }
  }
}
</script>
<style lang="scss">
 .payment_result {
   height: calc(var(--app-height) - 93px);
   overflow-y: auto;
   display: flex;
   align-items: center;
   justify-content: center;

   .row {
     .contents_area {
       &.invoice {
         width: 600px;
         max-width: 600px;
         min-width: 600px;
         .header_container {
           display: flex;
           justify-content: space-between;
           align-items: center;
           margin-bottom: 55px;
         }
       }
     }
   }

 }
</style>